import { toast } from "react-toastify";
import { GetProductReview, ReviewProduct } from "../../Services/MainServices";

export const REVIEW_PRODUCT_REQUEST = "REVIEW_PRODUCT_REQUEST";
export const REVIEW_PRODUCT_SUCCESS = "REVIEW_PRODUCT_SUCCESS";
export const REVIEW_PRODUCT_FAILURE = "REVIEW_PRODUCT_FAILURE";

export const GET_PRODUCT_REVIEW_REQUEST = "GET_PRODUCT_REVIEW_REQUEST";
export const GET_PRODUCT_REVIEW_SUCCESS = "GET_PRODUCT_REVIEW_SUCCESS";
export const GET_PRODUCT_REVIEW_FAILURE = "GET_PRODUCT_REVIEW_FAILURE";

const createProductReviewRequest = (payload) => ({
  type: REVIEW_PRODUCT_REQUEST,
  payload,
});

const createProductReviewSuccess = (payload) => ({
  type: REVIEW_PRODUCT_SUCCESS,
  payload,
});

const createProductReviewFailure = (error) => ({
  type: REVIEW_PRODUCT_FAILURE,
  payload: error,
});

const getProductReviewRequest = (payload) => ({
  type: GET_PRODUCT_REVIEW_REQUEST,
  payload,
});

const getProductReviewSuccess = (payload) => ({
  type: GET_PRODUCT_REVIEW_SUCCESS,
  payload,
});

const getProductReviewFailure = (error) => ({
  type: GET_PRODUCT_REVIEW_FAILURE,
  payload: error,
});

export const createProductReview = (reviewData) => async (dispatch) => {
  dispatch(createProductReviewRequest(reviewData));
  try {
    // Assuming you have an API function to submit the review
    const response = await ReviewProduct(reviewData);

    if (response?.data?.status === "success") {
      // Normalize returned data
      const data = response.data.data;
      dispatch(createProductReviewSuccess(data));
      // Optionally show a success message
      toast.success("Review submitted successfully!");
    } else {
      throw new Error(response.data.message || "Failed to submit review");
    }
  } catch (error) {
    // console.error("Error submitting product review:", error);
    dispatch(
      createProductReviewFailure(error.message || "Failed to submit review")
    );
    // Optionally show an error message
    toast.error(error.message || "Failed to submit review");
  }
};

export const getProductReview = (productId) => async (dispatch) => {
  dispatch(getProductReviewRequest());
  try {
    const response = await GetProductReview(productId);
    if (response?.data?.status === "success") {
      const data = response.data.data;
      // console.log("Fetched product reviews:", data);

      dispatch(getProductReviewSuccess(data));
    } else {
      throw new Error(response.data.message || "Failed to fetch reviews");
    }
  } catch (error) {
    // console.error("Error fetching product reviews:", error);
    dispatch(
      getProductReviewFailure(error.message || "Failed to fetch reviews")
    );
  }
};
